export const AICHAT_HIDDEN_CONTEXT_SESSION_KEY = 'aichatHiddenContext';

export interface AIChatHiddenContext {
  source?: string;
  brief_context_type?: string;
  brief_context_key?: string;
  landing_key?: string;
  seo_page_slug?: string;
  route_prefix?: string;
  page_title?: string;
  page_subtitle?: string;
  ad_keyword?: string;
}

export function writeAIChatHiddenContext(context: AIChatHiddenContext): void {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.setItem(AICHAT_HIDDEN_CONTEXT_SESSION_KEY, JSON.stringify(context || {}));
}

export function readAIChatHiddenContext(): AIChatHiddenContext | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const raw = sessionStorage.getItem(AICHAT_HIDDEN_CONTEXT_SESSION_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    sessionStorage.removeItem(AICHAT_HIDDEN_CONTEXT_SESSION_KEY);
    return null;
  }
}

export function clearAIChatHiddenContext(): void {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.removeItem(AICHAT_HIDDEN_CONTEXT_SESSION_KEY);
}
